export const configKeys = {
  filesTotalSpace: 'filesTotalSpace', // total space to store files (in MB)
}
